import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SearchState {
	inputValue: string;
	search: string;
	queryParam: string;
	setSearch: (value: string, callback?: (value: string) => void) => void;
	updateSearch: (value: string) => void;
	setInitialValue: (value: string) => void;
	setQueryParam: (param: string) => void;
	initializeFromUrl: () => void;
}

export const useSearchStore = create<SearchState>()(
	devtools(
		(set, get) => {
			let timeoutId: number | null = null;

			const updateSearch = (value: string, callback?: (value: string) => void) => {
				set({ search: value });
				callback?.(value);

				const { queryParam } = get();
				if (queryParam) {
					const url = new URL(window.location.href);
					if (value) url.searchParams.set(queryParam, value);
					else url.searchParams.delete(queryParam);
					window.history.replaceState({}, '', url.toString());
				}
			};

			return {
				inputValue: '',
				search: '',
				queryParam: '',
				setSearch: (value: string, callback?: (value: string) => void) => {
					set({ inputValue: value });
					if (timeoutId) clearTimeout(timeoutId);
					if (value.length === 0) {
						updateSearch(value, callback);
						return;
					}
					timeoutId = window.setTimeout(() => {
						updateSearch(value, callback);
					}, 300); // Default delay of 300ms
				},
				updateSearch: (value: string) => {
					set({ inputValue: value });
					updateSearch(value);
				},
				setInitialValue: (value: string) => {
					set({ inputValue: value, search: value });
				},
				setQueryParam: (param: string) => {
					set({ queryParam: param });
					// Re-initialize from URL with new param
					get().initializeFromUrl();
				},
				initializeFromUrl: () => {
					const { queryParam } = get();
					if (queryParam) {
						const url = new URL(window.location.href);
						const queryValue = url.searchParams.get(queryParam);
						if (queryValue) {
							set({ inputValue: queryValue, search: queryValue });
						}
					}
				},
			};
		},
		{
			name: 'search-store',
		},
	),
);

// Initialize the store from URL after it's created
useSearchStore.getState().initializeFromUrl();
